// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CollectRouteSiteList } from './../../types/routeManagementTypes';
import { RootState } from '../store';

type CollectingRouteState = {
  collectingRouteSites: CollectRouteSiteList | null;
  collectedTotalWeight?: string;
};

const initialState: CollectingRouteState = {
  collectingRouteSites: null,
};

export const collectingRouteSlice = createSlice({
  name: 'collectingRoute',
  initialState,
  reducers: {
    setCollectingRouteSites: (state, action) => {
      state.collectingRouteSites = action.payload;
    },
    resetCollectingRouteSites: (state) => {
      state.collectingRouteSites = null;
    },
    setRouteSiteHasMemo: (
      state,
      action: PayloadAction<{
        siteId: string;
        hasMemo: boolean;
      }>
    ) => {
      const { siteId, hasMemo } = action.payload;

      if (state.collectingRouteSites) {
        const siteIndex = state.collectingRouteSites.sites.findIndex(
          (site) => site.id === siteId
        );

        if (siteIndex !== -1) {
          state.collectingRouteSites.sites[siteIndex].hasMemo = hasMemo;
        }
      }
    },
    setCollectedTotalWeight: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.collectedTotalWeight = action.payload;
    },
    resetCollectedTotalWeight: (state) => {
      state.collectedTotalWeight = undefined;
    },

    resetAllCollectingRouteState: (state) => {
      state.collectingRouteSites = null;
      state.collectedTotalWeight = undefined;
    },
  },
});

export const {
  setCollectingRouteSites,
  resetCollectingRouteSites,
  setRouteSiteHasMemo,
  setCollectedTotalWeight,
  resetCollectedTotalWeight,
  resetAllCollectingRouteState,
} = collectingRouteSlice.actions;

export const selectCollectingRouteSites = (state: RootState) =>
  state.collectingRoute.collectingRouteSites;

export const selectCollectedTotalWeight = (state: RootState) =>
  state.collectingRoute.collectedTotalWeight;

export default collectingRouteSlice.reducer;
